import { Box, Tabs, Tab, HStack, VStack, TabList } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Breadcrumbs } from 'packages/common-frontend/components/Breadcrumbs';
import {
  LoanAccountTag,
  useLoanAccountUrlParam,
} from 'valleyBank/domains/LoanAccounts/hooks/LoanAccountContext';

const TABS = [
  {
    key: 'summary' as const,
    label: 'Summary',
    route: '/loan-accounts/summary',
  },
  {
    key: 'holdings' as const,
    label: 'Holdings',
    route: '/loan-accounts/holdings',
  },
];

export type LoanAccountDetailsTab = typeof TABS[number]['key'];

export const LoanAccountsDetailsTabs: React.FC<{
  selectedTab: LoanAccountDetailsTab;
}> = ({ selectedTab }) => {
  const history = useHistory();
  const { generateLoanAccountUrl } = useLoanAccountUrlParam();
  return (
    <Tabs
      variant="line"
      index={TABS.findIndex(({ key }) => key === selectedTab)}
      colorScheme="blue"
      background="white"
    >
      <TabList>
        {TABS.map(({ label, route }) => (
          <Tab
            key={route}
            onClick={() => history.push(generateLoanAccountUrl(route))}
          >
            {label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export const LoanAccountsDetailsTemplate: React.FC<{
  selectedTab: LoanAccountDetailsTab;
  headerChildren?: React.ReactNode;
  children: React.ReactNode;
}> = ({ selectedTab, children, headerChildren }) => {
  const { loanAccountId, generateLoanAccountUrl } = useLoanAccountUrlParam();

  const breadCrumbs = [
    { label: 'Loan Accounts', path: '/loan-accounts' },
    {
      label: `Loan Account Number: ${loanAccountId}`,
      path:
        selectedTab === 'summary'
          ? undefined
          : generateLoanAccountUrl('/loan-accounts/summary'),
    },
  ];

  if (selectedTab === 'holdings') {
    breadCrumbs.push({
      label: 'Holdings',
      path: generateLoanAccountUrl('/loan-accounts/holdings'),
    });
  }

  return (
    <>
      <VStack spacing="32px" w="100%" p="40px" alignItems="flex-start">
        <Breadcrumbs breadcrumbs={breadCrumbs} />
        <HStack spacing="16px">
          {loanAccountId && (
            <LoanAccountTag loanAccountId={loanAccountId || ''} />
          )}
          {headerChildren}
        </HStack>
      </VStack>
      <LoanAccountsDetailsTabs selectedTab={selectedTab} />
      <Box w="100%" mt="40px">
        {children}
      </Box>
    </>
  );
};
